import { selfAxios } from "../../../../../axios/selfAxios.js";
async function postSplitOrder(params) {
  const { data } = await selfAxios.post(`/designapi/design/softwareOneKey/splitOrder`, params);
  return data;
}
async function postSplitOrderNew(params) {
  const { data } = await selfAxios.post(`/designapi/kjl/order/spliteOrder`, params);
  return data;
}
export { postSplitOrder, postSplitOrderNew };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/softwareOneKey/splitOrder/post.js